import { TaskReq } from './task-req'
import { QuestionnaireRes } from './questionnaire-res'

export interface QuestionnaireActivityTaskResInterface {
  /**
   * 活动任务
   */
  task: TaskReq
  questionnaire: QuestionnaireRes
  isSubmit?: boolean
}

export class QuestionnaireActivityTaskRes
  implements QuestionnaireActivityTaskResInterface
{
  /**
   * 活动任务
   */
  task: TaskReq
  questionnaire: QuestionnaireRes
  isSubmit?: boolean

  constructor(props: QuestionnaireActivityTaskResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      task: _task,
      questionnaire: _questionnaire,
      isSubmit: _isSubmit,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.task = _task ? new TaskReq(_task) : _task
    this.questionnaire = _questionnaire
      ? new QuestionnaireRes(_questionnaire)
      : _questionnaire
    this.isSubmit = _isSubmit
  }
}
